import React from "react";

const ImageComponent = (props) => {
  // url = tên ảnh và đường link ,
  // className nếu muốn css riêng cho ảnh
  return (
    <img
      alt="base-img"
      title={props.title ?? ""}
      className={props?.className ?? "class-imgage-base"}
      style={props?.style ?? {}}
      src={process.env.PUBLIC_URL + props.url}
      onClick={() => {
        if (props.onClick) props.onClick();
      }}
    />
  );
};

export default ImageComponent;
